var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("rect",{"strokeLinecap":"square","x":"4","y":"14","width":"56","height":"36","rx":"4","key":0}),React.createElement("path",{"d":"M59.5 15.5L32 37 4.5 15.5m32.7 17.495L58.5 48.5 37.2 32.995zM27 33L5 49","key":1})]));
}

EmailInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
